module.exports = __webpack_public_path__ + "static/media/life-loader-purplish-blue.a38cdc20.gif";